// import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import './autocomplete.css';

import { contactsAddNewCustomer } from '../../../redux/actions/contacts';
import { fetchConToken } from '../../../helpers/fetch';
import { toast } from 'react-toastify';

const filter = createFilterOptions();

export const AutocompleteCustomers = ({ form, handleChangeCustomer }) => {

    const dispatch = useDispatch()
    const { listCustomers } = useSelector(state => state.contacts)
    console.log('--listCustomers--', listCustomers)

    const handleChange = async (e, newValue) => {

        const values = {
            id: newValue.id ? newValue.id : null,
            nombre: newValue.id ? newValue.nombre : newValue.inputValue,
            clasificacion: 'cliente'
        }

        let customer = {
            'id_cliente': values.id,
            'cliente': values.nombre
        }

        if (!newValue.id) {

            // Creando nuevo cliente
            const newContact = values
            const resp = await fetchConToken('contacts', newContact, 'POST');
            const body = await resp.json();
            if (body.ok) {
                toast.success(body.msg);
                console.log('--data return--', body.data)
                dispatch(contactsAddNewCustomer(body.data));
                customer.id_cliente = body.data.id || null;
                customer.cliente = body.data.nombre || null;
            }

        }

        handleChangeCustomer(customer)

    }

    return (
        <Autocomplete
            value={listCustomers.find((it) => (parseInt(it.id) === parseInt(form.id_cliente))) || null}
            onChange={(e, newValue) => handleChange(e, newValue)}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;

                // Suggest the creation of a new value
                const isExisting = options.some((option) => inputValue === option.nombre);
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        nombre: `Crear  "${inputValue}"`,
                    });
                }

                return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="free-solo-with-text-demo"
            options={listCustomers}
            getOptionLabel={(option) => {

                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }

                // Add "xxx" option created dynamically
                if (option.inputValue) {
                    return option.inputValue;
                }

                // Regular option
                return option.nombre;
            }}
            renderOption={(props, option) => <li {...props}>{option.nombre}</li>}
            sx={{ width: '100%' }}
            size='small'
            freeSolo
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Cliente"
                    placeholder='Ingrese nombre de tu cliente'
                    inputProps={{
                        ...params.inputProps,
                        style: { textTransform: 'capitalize' }
                    }}
                />
            )}
            disabled={form.reading_mode}
        />
    );
}